var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgThreeStars = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.549.564c.273-.752 1.337-.752 1.61 0l.263.722.722.263c.752.273.752 1.337 0 1.61l-.722.263-.262.722c-.274.752-1.338.752-1.611 0l-.263-.722-.722-.262c-.752-.274-.752-1.338 0-1.611l.722-.263.263-.722Zm7.47 1.216c-.273-.752-1.337-.752-1.61 0l-.645 1.773-1.772.644c-.753.274-.753 1.338 0 1.611l1.772.645.644 1.772c.274.752 1.338.752 1.611 0l.645-1.772 1.772-.645c.752-.273.752-1.337 0-1.611l-1.772-.644-.645-1.773ZM3.894 6.387c-.273-.753-1.337-.753-1.61 0l-.46 1.26-1.26.459c-.752.273-.752 1.337 0 1.61l1.26.46.46 1.26c.273.752 1.337.752 1.61 0l.459-1.26 1.26-.46c.753-.273.753-1.337 0-1.61l-1.26-.459-.459-1.26Z",
  fill: "var(--color-primary-info)"
})));

const ForwardRef = /*#__PURE__*/forwardRef(SvgThreeStars);
export default ForwardRef;